export default function isNumber(item) {
  return /^-|[0-9.]+/.test(item);
}



// WEBPACK FOOTER //
// ./src/logic/isNumber.js